module.exports = __webpack_public_path__ + "static/img/M-3.0d4674f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-3.png
// module id = JIYE
// module chunks = 0